import styled from 'styled-components';

export const Page = styled.div``;

export const Header = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto 0; padding: 0 16px;
  h1{ color: ${({ theme }) => theme.colors.green[700]}; margin: 0 0 6px; }
`;

export const HeaderImage = styled.div`
  max-width: ${({ theme }) => theme.container};
  margin: 16px auto 0; padding: 0 16px;
  border-radius: 12px; overflow: hidden; background: ${({ theme }) => theme.colors.gray[100]}; min-height: 220px;
  img{ width:100%; height:100%; object-fit: cover; border-radius: 12px; }
`;

export const Section = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 16px auto 0; padding: 0 16px;
`;

export const Grid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const Item = styled.div`
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  background: ${({ theme }) => theme.colors.gray[100]};
  cursor: pointer;
  transition: transform 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  img{
    width: 100%;
    height: auto;
    display: block;
  }
  div{ padding: 10px; }
  h4{ margin: 0 0 4px; color: ${({ theme }) => theme.colors.green[700]}; }
  p{ margin: 0; }
  &:hover{
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  }
`;

export const LightboxOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 1000;
`;

export const LightboxBody = styled.div`
  position: relative;
  max-width: 1000px;
  width: 100%;
  max-height: 90vh;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
`;

export const LightboxImage = styled.img`
  width: 100%;
  max-height: 80vh;
  object-fit: contain;
  display: block;
  background: #000000;
`;

export const LightboxCaption = styled.div`
  padding: 12px 16px;
  color: #111827;
  h4{ margin: 0 0 4px; }
  p{ margin: 0; font-size: 14px; opacity: 0.8; }
`;

export const LightboxClose = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  border: none;
  background: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  padding: 4px 10px;
  border-radius: 999px;
  cursor: pointer;
  font-size: 14px;
`;
